
import React from 'react';
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronUp, ChevronDown } from "lucide-react";
import { TSPEvent } from "@/types/tsp";

interface KitHeaderProps {
  kitNumber: number;
  viewMode: "ticker" | "scoreboard";
  selectedGame?: TSPEvent;
  isHeaderCollapsed: boolean;
  onViewModeChange: (mode: "ticker" | "scoreboard") => void;
  onHeaderCollapse: (collapsed: boolean) => void;
}

export function KitHeader({
  kitNumber,
  viewMode,
  selectedGame,
  isHeaderCollapsed,
  onViewModeChange,
  onHeaderCollapse,
}: KitHeaderProps) {
  return (
    <>
      <div className={`transition-all duration-300 ${isHeaderCollapsed ? 'h-12 overflow-hidden' : ''}`}>
        <div className="flex items-center mb-2 sm:mb-4">
          <div className="flex items-center gap-2 sm:gap-4">
            <Link to="/dashboard">
              <Button variant="ghost" size="icon">
                <ChevronLeft className="h-4 w-4" />
              </Button>
            </Link>
            <div className="flex items-center gap-4">
              <h1 className="text-xl sm:text-2xl font-bold">Kit {kitNumber} Control</h1>
              {selectedGame && viewMode === "scoreboard" && (
                <span className="text-white/80 text-lg">
                  {selectedGame.meta.event_away_team_abbreviation} vs {selectedGame.meta.event_home_team_abbreviation}
                </span>
              )}
            </div>
          </div>
          <div className="flex gap-2 ml-auto">
            <Button
              variant={viewMode === "ticker" ? "default" : "outline"}
              onClick={() => onViewModeChange("ticker")}
              className="text-sm sm:text-base"
            >
              Ticker
            </Button>
            <Button
              variant={viewMode === "scoreboard" ? "default" : "outline"}
              onClick={() => onViewModeChange("scoreboard")}
              className="text-sm sm:text-base"
            >
              Scoreboard
            </Button>
          </div>
        </div>
      </div>

      {selectedGame && viewMode === "scoreboard" && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onHeaderCollapse(!isHeaderCollapsed)}
          className="w-full mb-1 text-white/60 hover:text-white"
        >
          {isHeaderCollapsed ? <ChevronDown className="h-4 w-4" /> : <ChevronUp className="h-4 w-4" />}
        </Button>
      )}
    </>
  );
}
